import {IEvent} from "./i-event.interface";
import {EventName} from "./event-name.enum";

export class SystemEvent<T> implements IEvent<T>{

  private readonly _name: EventName;

  private readonly _payload: T | undefined;

  public get name(): EventName {
    return this._name;
  }

  public get payload(): T | null {
    return this._payload ?? null;
  }

  constructor(name: EventName, payload?: T) {
    this._name = name;
    if (payload) {
      this._payload = payload;
    }
  }
}